import {mapGetters} from "vuex";
import {capitalize} from "lodash";
import moment from "moment/moment";
import featureMixin from "@/mixins/featureMixin";


const urlHasProtocol = (url) => {
	let protocolRegex = /^(http|https|ftp|file):\/\//i;
	return protocolRegex.test(url);
}

export default {
	props: {
		product: {
			type: Object,
			required: true
		}
	},
	mixins: [featureMixin],

	computed: {
		...mapGetters(['language', 'lang']),
		...mapGetters('landingPage', ['currentFlyer']),
		...mapGetters('screen', ['flyerOrientation']),
		...mapGetters('raddar', ['isRaddar']),

		priceQty() {
			const qty = this.extractProductProp('priceQuantity');
			if(qty) return `${qty}`;
			return '';
		},

		bodyEn(){
			if(this.config?.bilingualCopy) return this.extractProductProp('bodyFr') +'\n'+this.extractProductProp('bodyEn');
			const bodyEn = this.language === 'fr' ? this.extractProductProp('bodyFr') : this.extractProductProp('bodyEn')
			return bodyEn.replace(/\s\•/g, '\n•');
		},

		pricePrefix(){
			return this.language === 'fr' ? this.extractProductProp('salePricePrefixFr') : this.extractProductProp('salePricePrefixEn')
		},

		limitQty(){
			return this.extractProductProp('limitQty') || '';
		},

		rowSave(){
			return this.language === 'fr' ? this.extractProductProp('rowSaveFr') : this.extractProductProp('rowSaveEn')
		},
		rowPrice(){
			let p=this.extractProductProp('rowPrice')
			if (!p || p === '$NaN' || p === 'NaN$') {
				return '';
			}

			if(!isNaN(p)) {
				p = parseFloat(p).toFixed(2);
				if(this.language === 'fr') {
					p = p.replace('.', ',');
				}
			}
			return this.formatCurrency(p);
		},

		rowPriceUnit(){
			return this.extractProductProp('rowPriceUnit') || '';
		},

		rowPriceQty(){
			return this.extractProductProp('rowPriceQty') || '';
		},

		salePrice() {
			let price = this.extractProductProp('salePrice') ;

			if (!price || price === '$NaN' || price === 'NaN$') {
				return '';
			}

			if(!isNaN(price)) {
				price = parseFloat(price).toFixed(2);
				if(this.language === 'fr') {
					price = price.replace('.', ',');
				}
			}
			return this.formatCurrency(price);
		},
		memberPrice(){
			let price = this.language === 'en' ? this.extractProductProp('memberPriceEn') : this.extractProductProp('memberPriceFr')

			if (!price || price === '$NaN' || price === 'NaN$') {
				return '';
			}

			if(!isNaN(price)) {
				price = parseFloat(price).toFixed(2);
				if(this.language === 'fr') {
					price = price.replace('.', ',');
				}
			}
			return this.formatCurrency(price);
		},
        regularPrice() {
			let p=this.extractProductProp('regularPrice')
			if (!p || p === '$NaN' || p === 'NaN$') {
				return '';
			}

			if(!isNaN(p)) {
				p = parseFloat(p).toFixed(2);
				if(this.language === 'fr') {
					p = p.replace('.', ',');
				}
			}
			return this.formatCurrency(p);
		},

		taxSuffix() {
                return this.extractProductProp('tx') || '';
		},
		memberPriceQty(){
			const qty = this.extractProductProp('memberPriceQuantity');
			if(qty) return `${qty}`;
			return '';
		},
		memberPricePrefix(){
			return this.language === 'en' ? this.extractProductProp('memberPricePrefixEn') : this.extractProductProp('memberPricePrefixFr')
		},
		memberPriceUnit(){
			return this.extractProductProp('memberPriceUnit') || '';
		},
		memberSavePrefix(){
			return this.formatCurrency(this.extractProductProp('memberSavePrefix') || '');
		},
		memberSave(){
			return this.extractProductProp('memberSave')
		},
		memberSaveSuffix(){
			return this.language === 'en' ? this.extractProductProp('memberSaveSuffixEn') : this.extractProductProp('memberSaveSuffixFr')
		},
		alternatePrice() {
			return this.formatCurrency(this.extractProductProp('alternatePrice')) || '';
		},
		promoUnit() {
			return this.language === 'fr' ? (this.extractProductProp('promoUnitFr')) : this.extractProductProp('promoUnitEn')
		},
		priceLine() {
			return `${this.priceQty}${this.pricePrefix}${this.salePrice} ${this.promoUnit}`;
		},
		savings() {
			if(this.config.hideSavings)return '';
			return this.language === 'fr' ? this.extractProductProp('savingsFr') : this.extractProductProp('savingsEn')
		},
		savingsPrefix(){
			return this.language === 'fr' ? this.extractProductProp('savingsPrefixFr') : this.extractProductProp('savingsPrefix')
		},
		savingsSuffix(){
			return this.language === 'fr' ? this.extractProductProp('savingsSuffix') : this.extractProductProp('savingsSuffix')
		},
		loyalty() {
			return this.extractProductProp('loyalty');
		},
		loyaltyPrefix(){
			return this.extractProductProp('loyaltyPrefix');
		},
		loyaltySuffix(){
			return this.extractProductProp('loyaltySuffix');
		},

		productName() {
			return this.extractProductProp('product');
		},
		description(){
			if(this.config.hideDetails)return '';
			return this.extractProductProp('body', true) || this.extractProductProp('product') || this.extractProductProp('body')
		},
		htmlDescription() {
			return this.description.replace(/\*\*/g, '<br>**').replace(/(^|\s)\*(?=\S)/g, '<br>*').replace(/-/g, '&#x2011;');
		},
		productURLLDF() {
			let utm_source = this.isRaddar ? 'raddar' : 'TC_hosted';
			const utm_medium = `digital_flyer`
			const formattedDate = this.currentFlyer.startDate?.split('T')[0].replace(/-/g, '')
			const flyerCategory = this.currentFlyer.flyerCategory?.replace(/ /g, '_').toLowerCase();
			const utm_campaign = `${flyerCategory}_${this.dealId?.replace(/ /g, '_')}_${formattedDate}`
			let utm;
			if(this.product.url.includes('?')) {
                utm = `&utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`
			} else {
                utm = `?utm_source=${utm_source}&utm_medium=${utm_medium}&utm_campaign=${utm_campaign}`
			}

			if(this.config.productURL) {
				return this.config.productURL.replaceAll('${sku}', this.sku);
			}
			let url = this.extractProductProp('url');
			if(!url) return url;

			if(!urlHasProtocol(url)) {
				url = `https://${url}`;
			}
			return `${url}${utm}`;
		},
		isProductURL() {
			if (this.features?.pdp?.disableShopNow && this.currentFlyer.flyerType.toLowerCase() === 'preview') return;
			return  (this.product?.url && this.language === 'en') ? this.product.url : false
	    },
		productURL() {
			if(this.config.productURL) {
				return this.config.productURL
					.replaceAll('${sku}', this.sku)
					.replaceAll('/en/','/' + this.language + '/');
			}
			let url = this.extractProductProp('url');
			if(!url) return url;

			if(!urlHasProtocol(url)) {
				url = `https://${url}`;
			}

			if(!url){
				const clickRegionWithUrl = this.product.clickRegions.find(clickRegion => clickRegion.url)
				if(clickRegionWithUrl){
					url = clickRegionWithUrl.url;
				}
			}


			return url;
		},
		productImage(){
			if(this.extractProductProp('productImage')==='' && this.config.useBlockImage) return this.product?.blockData?.images?.findLast((item) => {
				return item?.image;
			}).image;

			return this.extractProductProp('productImage');
		},
		sku() {
			return this.extractProductProp('sku');
		},
		showProductName() {
			return this.productName !== this.description;
		},
		useRow() {
			if(!this.extractProductProp('validFromROW'))return false;

			const vfr = moment(this.extractProductProp('validFromROW')).startOf('day');
			const vft = moment(this.extractProductProp('validToROW')).endOf('day');
			return moment().isBetween(vfr, vft);
		},
		validFrom() {
			if(this.config.useFlyerValidity)return this.formatDate(this.currentFlyer.startDate);

			return this.formatDate( this.useRow? this.extractProductProp('validFromROW'): this.extractProductProp('validFrom') || this.currentFlyer.startDate);
		},
		validTo(){
			if(this.config.useFlyerValidity)return this.formatDate(this.currentFlyer.endDate);
			return this.formatDate(this.useRow? this.extractProductProp('validToROW'): this.extractProductProp('validTo') || this.currentFlyer.endDate);
		},
		htmlValidity() {
			return `<span class="date-item">${this.validFrom}</span> ${this.language === 'en'? 'to':'jusqu\'au'} <span class="date-item">${this.validTo}</span>`;
		}
	},
	methods: {
		/**
		 * Extracts the product property based on the given property name and language strictness.
		 * If langStrict is true, it returns the language-specific property value if it exists, or an empty string if it doesn't.
		 * If langStrict is false, it tries to find the specified language-specific property if it exists,
		 * otherwise it returns the default property value if it exists, or an empty string if neither exist.
		 *
		 * @param {string} prop - The name of the property to extract.
		 * @param {boolean} langStrict - Determines the language strictness. If true, it only returns the language-specific property value if it exists. If false, it falls back to the default property value if the language-specific property doesn't exist.
		 * @returns {string} - The extracted product property value.
		 */
		extractProductProp(prop, langStrict) {
			const lang = this.config?.props?.[prop]?.lang || this.language;
			//const lang =  this.config?.props ? (this.config?.props[prop]?.lang || this.language) : this.language;
			//langStrict if true gets language locale only version of property if it exists, if false it tries to find either if specified language local doesn't exist
			const strict = this.product?.[`${prop}${capitalize(lang)}`] || this.product?.[prop];
			const loose = this.product?.[`${prop}En`] || this.product?.[`${prop}Fr`];
			if(langStrict) {
				return strict || '';
			}
			return strict || loose || '';
		},
		formatCurrency(currency) {
			const lang = this.language;
			if(currency === null || currency === undefined)return;

			const str = String(currency).replaceAll('$', '');

			const regex = /\d+([.,])\d{2}/g;

			const replacedString =  str.replace(regex, (match) => {
				if(lang === 'fr') {
					match = match.replace('.', ',') + '$';
				} else {
					match = '$' + match.replace(',', '.');
				}
				return match;
			});
			if (replacedString === str)
				return String(currency)

			return replacedString
		},
		formatDate(date) {
			return moment.utc(date).locale(this.language).format(this.language === 'en'? 'MMMM D, YYYY': 'D MMMM, YYYY');
		}
	}
}
